import React, { Component } from 'react'
import intl from 'react-intl-universal'
import AuthorisationHandler from '../components/AuthorisationHandler'
import ResultsInnerExperience from '../components/ResultsInnerExperience'
import Loading from '../components/Loading'
import Page from './Page'
import ProfileMenu from '../components/ProfileMenu'
import shortid from 'shortid'
import { inject, observer, action, PropTypes } from 'mobx-react/index'

@inject('my_experiences', 'user')
@observer
class ProfileMyExperiencesPage extends Component {
  constructor (props) {
    super(props)

    const {user, my_experiences} = props
    const {token} = user
    my_experiences.get(token)
  }

  render () {
    const {user, my_experiences} = this.props
    const {grouped_experiences} = my_experiences
    console.log('ProfileMyBookingsPage - render() - grouped_experiences:', grouped_experiences)

    return (
      <AuthorisationHandler>
        <Page title='My experiences'>
          <section className='b-profile'>
            <div className='b-profile-inner'>

              <ProfileMenu />

              <div className='b-profile-main'>
                <h3 className='b-profile-title'>{intl.get('profile.my_experiences')}</h3>

                {!my_experiences.loaded
                  ? <div><Loading /></div>
                  : <div className='b-profile-experiences'>
                    {grouped_experiences
                      ? Object.entries(grouped_experiences).map(([group_name, group]) => {
                        if (group.length > 0) {
                          return (
                            <div key={shortid.generate()}
                                 className='b-profile-experiences-group'>
                              <div className='b-profile-experiences-group-items'>
                                {group.map((experience, index) =>
                                  <ResultsInnerExperience
                                    key={shortid.generate()}
                                    experience={experience}
                                    date={experience.formatted_date}
                                    date_label='Nächstes Event'
                                    is_before={experience.is_before}
                                    is_today={experience.is_today}
                                    is_after={experience.is_after}
                                    hide_expired_date={true}
                                    variant={experience.variant}
                                    topic={experience.topic || ' '}
                                    show_liked={false}
                                    show_price={false}
                                    show_table={true}
                                    show_rating={false}
                                    show_guests={true}
                                    show_user={false} />)}
                              </div>
                            </div>
                          )
                        }
                      })
                      : <div className='b-empty'><div className='b-empty-text'>{intl.get('No experiences')}</div></div>}
                  </div>}
              </div>
            </div>
          </section>
        </Page>
      </AuthorisationHandler>
    )
  }
}

ProfileMyExperiencesPage.propTypes = {
  my_experiences: PropTypes.observableObject,
  user: PropTypes.observableObject
}

export default ProfileMyExperiencesPage



// WEBPACK FOOTER //
// ./src/containers/ProfileMyExperiencesPage.js